import PageFilters from './PageFilters';

export default PageFilters;



// WEBPACK FOOTER //
// ./scripts/elements/PageFilters/index.js